var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderConstructionSection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECTS",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 396.1 220.2",
    style: {
      enableBackground: "new 0 0 396.1 220.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#242933;}\n\t.st1{opacity:0.7;fill:#CCCCCC;}\n\t.st2{fill:#F77F4F;}\n\t.st3{fill:#5C5C5C;}\n\t.st4{fill:#969696;}\n\t.st5{fill:#E5B848;}\n\t.st6{fill:#E4A544;}\n\t.st7{fill:#959595;}\n\t.st8{fill:#646464;}\n\t.st9{fill:#727272;}\n\t.st10{fill:#BABABA;}\n\t.st11{fill:#E3E3E3;}\n\t.st12{fill:#C3663F;}\n\t.st13{fill:#FFFFFF;}\n\t.st14{opacity:0.5;fill:#333333;}\n\t.st15{fill:#DCBB85;}\n\t.st16{fill:#C7AA79;}\n\t.st17{fill:#F1CC90;}\n\t.st18{fill:none;}\n\t.st19{fill:#E5C289;}\n\t.st20{fill:#61421E;}\n\t.st21{fill:#974F31;}\n\t.st22{fill:#F4DB96;}\n\t.st23{fill:#593D1C;}\n\t.st24{fill:#4C3418;}\n\t.st25{fill:#E2764A;}\n\t.st26{fill:#7F2E21;}\n\t.st27{fill:#9D3929;}\n\t.st28{fill:#4E3518;}\n\t.st29{fill:#392711;}\n\t.st30{fill:#D87E41;}\n\t.st31{fill:#C9663A;}\n\t.st32{fill:#699E9E;}\n\t.st33{fill:#477274;}\n\t.st34{fill:#315052;}\n\t.st35{fill:#CFC552;}\n\t.st36{fill:#EDEDED;}\n\t.st37{fill:#7B673C;}\n\t.st38{fill:#8F7846;}\n\t.st39{fill:#B49858;}\n\t.st40{fill:#C4A560;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.8,192.9c0,0-2-2.5-1.1-3.7c0.9-1.2,2.4-3.2,2.4-3.2s-0.1-2.4,1.5-2.7c1.7-0.3,5.1,0.8,5.1,0.8l2.7,3.7 c0,0,2.9,1,3.1,1.6c0.1,0.7-0.7,3.4-1.6,3.5C122,193.2,114.2,192.9,112.8,192.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.9,192.1c0,0-1.4-4.1-3.1-4.4c-1.7-0.4-3-0.5-3.5-0.3c-0.5,0.2-3.7,2-3.7,2s-2.4,1.4-2.4,2.1 c0,0.7,0,0.8,1.7,1.3c1.7,0.5,9,0.3,9,0.3S108.9,193.6,108.9,192.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M373,197.3c0,0-1.4-1.8-0.8-2.7c0.7-0.9,1.7-2.3,1.7-2.3s-0.1-1.7,1.1-1.9c1.2-0.2,3.7,0.6,3.7,0.6l1.9,2.7 c0,0,2.1,0.7,2.2,1.2c0.1,0.5-0.5,2.5-1.1,2.5C379.7,197.5,374.1,197.3,373,197.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M341.4,193.8l30.5-0.6c0,0,1.4-3.8,0-5c-1.4-1.2-0.6-3.5-0.6-5c0-1.5-1.7-4.1-2.5-4.4c-0.8-0.2-7-4.7-8.7-2.8 c-1.7,2-3.6,3.8-4.5,3.9s-5.9-3.7-5.9-3.7s-4.2,3.1-4.8,3.7c-0.6,0.6-2.2,3.5-2,4.4c0.3,0.9-0.8,2.7-1.7,3.2 c-0.8,0.5-2.7,2.9-2.7,2.9L341.4,193.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M384,192.6c0,0,5.7,0.2,7.1,0c1.4-0.2,3.4-0.3,3.9-0.5c0.5-0.2,1.1-2.5,1.1-2.5H393c0,0-0.7-0.8-1-0.9 c-0.3-0.1-1-0.7-1.6-0.7s-3.4-0.5-4.3,0c-0.9,0.5-2.1-0.1-2.3,0.7c-0.2,0.8-1.4,1-1.5,1.5C382,190.7,382.4,192.6,384,192.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M367.4,203.5c0-2.2-68.5-9.2-153.6-9.2c-85.1,0-154.5,7-154.5,9.2c0,0.4,2,0.7,5.8,1.1 c-26.7,0.2-47.5,2.2-47.5,4.5c0,2.5,23.9,4.6,53.4,4.6c29.5,0,53.4-2,53.4-4.6c0-1-3.4-1.8-9.3-2.6c7.5,0.2,15.6,0.3,24.1,0.4 c-6.8,0.8-10.9,1.9-10.9,3.1c0,2.6,19.6,4.7,43.7,4.7s43.7-2.1,43.7-4.7c0-1-2.7-1.9-7.4-2.6c1.7,0,3.4,0,5,0 C298.5,207.4,367.4,205.6,367.4,203.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "225.7,141.5 234.7,134.6 235.3,129.7 239.4,125.8 238.6,124.9 234.2,129.2 233.6,134 225,140.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M236.8,125.4c0-1.2,1-2.1,2.1-2.1c1.2,0,2.1,1,2.1,2.1c0,1.2-1,2.1-2.1,2.1 C237.8,127.5,236.8,126.5,236.8,125.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "224.6,139.1 230.1,128.2 232.8,120.2 238,117.4 237.4,116.4 231.8,119.4 229,127.7 223.6,138.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M235.3,116.9c0-1.3,1.1-2.4,2.4-2.4c1.3,0,2.4,1.1,2.4,2.4c0,1.3-1.1,2.4-2.4,2.4 C236.4,119.3,235.3,118.2,235.3,116.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M147.8,198.2c-3.4-0.2-8.7-2.1-12.7-6.7c-2.5-2.9-5.3-8-4.5-15.7c1.2-11.6,8.7-18.1,21.2-18.4 c5.6-0.1,61.3-1.1,109-1.7c23-0.3,40.4-0.4,51.5-0.3c14.3,0,22.8,9.4,23.3,25.6l0,0.2c0.1,4-1.2,7.5-3.9,10.4 c-6.3,6.6-20,7.3-43.1,7.5C264.3,199.3,184.1,200.2,147.8,198.2z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "314.8,157.2 312.9,152.3 301.3,152.3 297,157.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297,157.2 295.1,152.9 283.4,152.9 279.1,157.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.1,157.2 277.3,152.3 265.6,152.3 261.3,157.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.3,157.2 259.5,154.2 247.8,154.2 243.5,157.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.5,158.4 241.7,152.3 230,152.3 225.7,158.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.7,158.4 223.9,152.3 212.2,152.3 207.9,158.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.9,158.4 206,154.2 194.4,154.2 190.1,158.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.1,157.8 188.2,152.9 176.6,152.9 172.3,157.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.3,158.4 169.4,152.3 157.7,152.3 153.4,158.4  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.2,157.2l5.7-3.1c0,0,9.8,3.7,10,7.4l-1.8,5.5l0.3,0.7l1.5,3.4l3.7,1.4c0,0,1.6,4.7,0,10.6l-2.7,0l-2.3,5.7 l1.8,4.1c0,0-4.9,4.7-8.8,5.3l-3.3-3.1l6.8-4.7l2.9-3.3l2-6.1l2-4.9l-4.7-6.6l-2.3-7.4l-6.1-3.9L317.2,157.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.9,197.4 309.6,201.5 319.1,199.5 319.1,196.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.2,197.6 298.6,201.5 288,201.5 285.9,197.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.1,197.6 280.6,203.1 270,203.1 267.9,197.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.1,197.6 262.6,201.5 252,201.5 249.9,197.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.1,197.6 244.5,202.3 234,202.3 231.8,197.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.1,197.6 226.5,201.5 216,201.5 213.8,197.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.1,197.6 208.5,201.5 198,201.5 195.8,197.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.1,197.6 190.5,201.5 179.9,201.5 177.8,197.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176,197.6 172.5,201.5 161.9,201.5 159.8,197.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158,197.6 154.4,201.1 145.1,200.1 143.5,196.1  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.7,195l-4.9,1c0,0-5.8-4.4-6.1-7.4l2.4-3.6L141.7,195z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.4,184.4l-4.4-2.2c0,0-1.8-7.1-0.2-9.6l4.1-1.3L133.4,184.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.3,173.3l-2.5-4.3c0,0,2.4-6.9,5.1-8.1l4.1,1.1L132.3,173.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.4,158.4l-2.2-4.3c0,0-10.1,1.3-11.1,2.7l0,5.3L152.4,158.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M294.9,172.2c2.5-8.7,11.6-13.8,20.3-11.3c8.7,2.5,13.8,11.6,11.3,20.3c-2.5,8.7-11.6,13.8-20.3,11.3 C297.4,190,292.4,180.9,294.9,172.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "308.6,190 304.1,195.8 300,193.7 301,187.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "302.6,187.2 295.9,190.2 293.3,186.3 297,181.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "298.7,181.9 291.3,181.3 290.9,176.7 296.3,174.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "297.8,175.3 291.6,171.4 293.4,167.1 299.3,167.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "300.1,169.2 296.5,162.7 300.1,159.8 305.1,163.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "305,164.8 304.9,157.4 309.5,156.6 312.3,161.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "311.5,163.4 314.9,156.8 319.3,158.3 319.3,164.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "317.8,165.1 323.9,161 327.1,164.4 324.3,169.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "322.5,169.7 329.9,169 331.1,173.5 326.1,176.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "324.5,176 331.3,178.9 330.2,183.4 324.3,183.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "323.3,182.5 327.9,188.2 324.8,191.7 319.4,189.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "319.1,187.6 320.4,194.8 316,196.4 312.4,191.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M256.4,172.9c2.5-8.7,11.6-13.8,20.3-11.3c8.7,2.5,13.8,11.6,11.3,20.3c-2.5,8.7-11.6,13.8-20.3,11.3 C259,190.7,253.9,181.6,256.4,172.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "270.1,190.7 265.7,196.6 261.5,194.4 262.5,188.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "264.1,187.9 257.4,190.9 254.8,187.1 258.5,182.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "260.2,182.6 252.9,182.1 252.4,177.4 257.9,175.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "259.3,176.1 253.1,172.1 254.9,167.8 260.8,168.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "261.6,169.9 258,163.5 261.7,160.5 266.6,163.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "266.6,165.5 266.5,158.2 271.1,157.3 273.9,162.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "273,164.1 276.4,157.6 280.9,159 280.8,165  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "279.4,165.9 285.5,161.8 288.7,165.1 285.8,170.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "284.1,170.4 291.4,169.7 292.6,174.2 287.7,177.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "286.1,176.7 292.9,179.6 291.8,184.1 285.9,184.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "284.8,183.2 289.4,188.9 286.3,192.4 280.9,190  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "280.7,188.3 282,195.6 277.6,197.1 274,192.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M216.9,173.4c2.5-8.7,11.6-13.8,20.3-11.3c8.7,2.5,13.8,11.6,11.3,20.3c-2.5,8.7-11.6,13.8-20.3,11.3 C219.4,191.2,214.4,182.1,216.9,173.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "230.5,191.2 226.1,197.1 222,194.9 223,189.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "224.6,188.4 217.9,191.4 215.3,187.6 218.9,182.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "220.7,183.1 213.3,182.6 212.9,177.9 218.3,175.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "219.8,176.6 213.5,172.6 215.4,168.3 221.3,168.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "222.1,170.4 218.5,164 222.1,161 227.1,164.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "227,166.1 226.9,158.7 231.5,157.9 234.3,163.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "233.4,164.6 236.9,158.1 241.3,159.5 241.3,165.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "239.8,166.4 245.9,162.3 249.1,165.7 246.3,170.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "244.5,171 251.9,170.3 253.1,174.8 248.1,178  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "246.5,177.2 253.3,180.1 252.2,184.7 246.3,185.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "245.3,183.7 249.9,189.5 246.8,193 241.3,190.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "241.1,188.8 242.4,196.1 238,197.7 234.4,193  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M176.7,173.4c2.5-8.7,11.6-13.8,20.3-11.3c8.7,2.5,13.8,11.6,11.3,20.3c-2.5,8.7-11.6,13.8-20.3,11.3 C179.3,191.2,174.3,182.1,176.7,173.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "190.4,191.2 186,197.1 181.8,194.9 182.8,189.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "184.5,188.4 177.8,191.4 175.1,187.6 178.8,182.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "180.6,183.1 173.2,182.6 172.8,177.9 178.2,175.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "179.6,176.6 173.4,172.6 175.2,168.3 181.2,168.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "181.9,170.4 178.3,164 182,161 186.9,164.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "186.9,166.1 186.8,158.7 191.4,157.9 194.2,163.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "193.3,164.6 196.7,158.1 201.2,159.5 201.2,165.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "199.7,166.4 205.8,162.3 209,165.7 206.1,170.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "204.4,171 211.7,170.3 213,174.8 208,178  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.4,177.2 213.2,180.1 212.1,184.7 206.2,185.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "205.2,183.7 209.8,189.5 206.7,193 201.2,190.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201,188.8 202.3,196.1 197.9,197.7 194.3,193  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M137.1,174.2c2.5-8.7,11.6-13.8,20.3-11.3c8.7,2.5,13.8,11.6,11.3,20.3c-2.5,8.7-11.6,13.8-20.3,11.3 C139.6,192,134.6,182.9,137.1,174.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "150.8,192 146.3,197.8 142.2,195.7 143.2,189.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "144.8,189.2 138.1,192.2 135.5,188.3 139.1,183.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "140.9,183.9 133.5,183.3 133.1,178.7 138.5,176.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "140,177.3 133.7,173.4 135.6,169.1 141.5,169.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "142.3,171.2 138.7,164.7 142.3,161.8 147.3,165.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "147.2,166.8 147.1,159.5 151.7,158.6 154.5,163.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "153.6,165.4 157.1,158.8 161.5,160.3 161.5,166.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "160,167.1 166.1,163 169.3,166.4 166.5,171.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "164.7,171.7 172.1,171 173.3,175.5 168.3,178.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "166.7,178 173.5,180.9 172.4,185.4 166.5,185.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "165.5,184.5 170.1,190.2 167,193.7 161.5,191.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "161.3,189.6 162.6,196.8 158.2,198.4 154.6,193.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M147.8,198.2c-3.4-0.2-8.7-2.1-12.7-6.7c-2.5-2.9-5.3-8-4.5-15.7c1.2-11.6,8.7-18.1,21.2-18.4 c5.6-0.1,61.3-1.1,109-1.7c23-0.3,40.4-0.4,51.5-0.3c14.3,0,22.8,9.4,23.3,25.6l0,0.2c0.1,4-1.2,7.5-3.9,10.4 c-6.3,6.6-20,7.3-43.1,7.5C264.3,199.3,184.1,200.2,147.8,198.2z M331.8,181.1c-0.2-8.2-3.1-21.9-19.5-21.9 c-11.1,0-28.4,0.1-51.4,0.3c-47.7,0.6-103.4,1.6-109,1.7c-10.6,0.2-16.5,5.3-17.5,15c-0.5,5,0.7,9.5,3.6,12.9 c3.2,3.7,7.4,5.2,10,5.4c36.2,2.1,116.2,1.2,140.4,0.9c21.7-0.3,35-0.6,40.4-6.4"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M303.8,174.7c1.1-4,5.3-6.4,9.4-5.2c4,1.1,6.4,5.3,5.2,9.4c-1.1,4-5.3,6.4-9.4,5.2 C305,182.9,302.7,178.7,303.8,174.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M265.4,175.4c1.1-4,5.3-6.4,9.4-5.2c4,1.1,6.4,5.3,5.2,9.4c-1.1,4-5.3,6.4-9.4,5.2 C266.6,183.7,264.2,179.5,265.4,175.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M225.8,176c1.1-4,5.3-6.4,9.4-5.2c4,1.1,6.4,5.3,5.2,9.4c-1.1,4-5.3,6.4-9.4,5.2 C227,184.2,224.7,180,225.8,176z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M185.7,176c1.1-4,5.3-6.4,9.4-5.2c4,1.1,6.4,5.3,5.2,9.4c-1.1,4-5.3,6.4-9.4,5.2 C186.9,184.2,184.6,180,185.7,176z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M146,176.7c1.1-4,5.3-6.4,9.4-5.2c4,1.1,6.4,5.3,5.2,9.4c-1.1,4-5.3,6.4-9.4,5.2 C147.2,184.9,144.9,180.7,146,176.7z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "299.2,138.6 338.7,145.6 338.7,169.3 125.7,171.5 130.4,140.4 152.4,138.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M270.2,131.7c0,0,1.9-41.1,6.7-43.6c4.8-2.5,3.9,44.6,3.9,44.6L270.2,131.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M73.2,99c0,0-4.3-6.8-4.1-13.2c0.2-6.4,16.8-12.2,16.8-12.2S73.4,97.4,73.2,99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M104,30.2c0,0-4.3-6.8-4.1-13.2c0.2-6.4,16.8-12.2,16.8-12.2S104.2,28.6,104,30.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "125,8.8 115.1,7.1 76.6,91.5 82.8,99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "116.7,6.1 114.8,5.2 75.2,92.1 77.1,93  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.8,
    y: 52.7,
    transform: "matrix(0.4241 -0.9056 0.9056 0.4241 11.2377 125.102)",
    className: "st6",
    width: 102.4,
    height: 2.1
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "119,17.5 113.5,8.1 115.1,4.5 118.3,3.7 122.4,4.6 128.3,10.2 129.5,12  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M235.7,48.6c0,0,1.8-17.9,10.4-17.7c8.6,0.2,23.5,17.7,23.5,17.7S245.9,52.8,235.7,48.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M145,30.8c0,0,11.1-6.9,14.8-1.9c3.7,5,0.3,21.4,0.3,21.4S147.2,38.6,145,30.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "194.5,125.5 208.9,115.5 129.3,10.9 116.1,13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "209,118.1 211.3,116.5 129.6,8.7 127.2,10.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: -1,
    transform: "matrix(0.8201 -0.5723 0.5723 0.8201 -11.7929 101.4749)",
    className: "st6",
    width: 2.9,
    height: 140.9
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "222.4,104.9 182.1,105.2 173.4,122.6 167.3,139.6 221.3,139.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M192.3,118.6c1.3-4.6,6.2-7.3,10.8-6c4.6,1.3,7.3,6.2,6,10.8c-1.3,4.6-6.2,7.3-10.8,6 C193.7,128,191,123.2,192.3,118.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M197.1,119.9c0.6-2.1,2.8-3.4,5-2.8c2.1,0.6,3.4,2.8,2.8,5c-0.6,2.1-2.8,3.4-5,2.8 C197.7,124.3,196.5,122.1,197.1,119.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "199.6,128 197.3,131.1 195.1,130 195.6,126.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196.5,126.5 192.9,128.1 191.5,126.1 193.5,123.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "194.4,123.7 190.5,123.4 190.2,121 193.1,119.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "193.9,120.2 190.6,118.1 191.5,115.9 194.7,116.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "195.1,117 193.2,113.5 195.1,112 197.8,113.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "197.7,114.7 197.7,110.7 200.1,110.3 201.6,113.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.2,113.9 203,110.4 205.3,111.2 205.3,114.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "204.5,114.8 207.8,112.6 209.5,114.4 208,117.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "207,117.3 210.9,116.9 211.6,119.3 208.9,121  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "208.1,120.6 211.7,122.1 211.1,124.5 208,124.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "207.4,124 209.9,127.1 208.2,128.9 205.4,127.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "205.2,126.8 205.9,130.6 203.6,131.4 201.7,129  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "202.4,121.7 201.7,135.2 198.9,135.2 199.6,121.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M198.9,121.4c0-1.2,1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2c0,1.2-1,2.2-2.2,2.2 C199.9,123.6,198.9,122.6,198.9,121.4z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 190.6,
    y: 135.2,
    className: "st3",
    width: 28.7,
    height: 4.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M299.8,138.4l-1.5-12.9L290.6,47l-67.3-1.9l-7.3,94.5L299.8,138.4z M285.8,55.5l6.1,74.3l-66.4,1.5 l2.7-77.3L285.8,55.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "102.6,19.3 104.5,15.1 107.1,16.2 105.3,21.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "87.6,54.2 74.2,84.8 76.2,85.7 90.4,54.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.2,
    y: 35.3,
    transform: "matrix(0.4002 -0.9164 0.9164 0.4002 23.1102 110.8076)",
    className: "st3",
    width: 40,
    height: 4.8
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "240.1,36.8 245.5,37 245.5,40.5 239.1,40.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "194.7,36 154.8,35.1 154.8,37.6 195.5,39.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.9,
    y: 14.3,
    transform: "matrix(2.295548e-02 -0.9997 0.9997 2.295548e-02 173.6931 253.9271)",
    className: "st3",
    width: 5.7,
    height: 47.7
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M243,39.4c-0.6-1.9,0.4-4,2.3-4.6c1.9-0.6,4,0.4,4.6,2.3c0.6,1.9-0.4,4-2.3,4.6 C245.7,42.4,243.6,41.3,243,39.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M151.1,36.5c0-2,1.6-3.7,3.7-3.7c2,0,3.7,1.6,3.7,3.7c0,2-1.6,3.7-3.7,3.7 C152.8,40.1,151.2,38.5,151.1,36.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M103.2,15.6c0-1.6,1.3-2.8,2.8-2.8c1.6,0,2.8,1.3,2.8,2.8c0,1.6-1.3,2.8-2.8,2.8 C104.5,18.4,103.2,17.1,103.2,15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M72.4,85.2c0-1.6,1.3-2.8,2.8-2.8c1.6,0,2.8,1.3,2.8,2.8c0,1.6-1.3,2.8-2.8,2.8 C73.6,88.1,72.4,86.8,72.4,85.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M115.6,14.6l2.1-2c-0.7-0.8-2.5-3.2-2.1-5.1c0.2-1.1,1.2-2,2.8-2.7c2.5-1.1,7.7,3.9,10.5,7.8l2.4-1.7 c-0.8-1.2-8.3-11.2-14-8.7c-2.6,1.1-4.1,2.7-4.5,4.8C112,10.6,115.2,14.2,115.6,14.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M116.1,8.1c0-2,1.6-3.7,3.7-3.7c2,0,3.7,1.6,3.7,3.7c0,2-1.6,3.7-3.7,3.7C117.7,11.8,116.1,10.2,116.1,8.1z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M89,91.6c0,0-8.5-3.9-12.1-1.7c-3.7,2.2-4.2,14.2-4.2,14.2L89,91.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "113.3,119.5 123.3,112.8 124.4,114.4 117.7,122.1 113.4,123.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M87.5,91.3c0,0-15,10.9-15.5,11.9c-5.4,10.5,4.5,53.4,45.7,18.9L87.5,91.3z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M78.8,93c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2C79.7,95,78.8,94.1,78.8,93z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,121c0,0-20-1.9-19.7,1.7c0.3,3.6,19.7,3.8,19.7,3.8V121z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 248.6,
    y: 145.5,
    className: "st6",
    width: 32.9,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.6,
    y: 154.3,
    className: "st6",
    width: 32.9,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.6,
    y: 163.1,
    className: "st6",
    width: 32.9,
    height: 2.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "117.7,172.1 121.5,203.5 121.1,203.9 121.6,207.1 115.3,207.2 111.3,172.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "107.2,172.3 103.4,203.7 103.8,204.1 103.3,207.3 109.6,207.4 113.6,172.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "179.1,173.2 175.3,204.6 175.6,205 175.1,208.2 181.4,208.3 185.4,173.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "189.5,173.4 193.3,204.8 193,205.2 193.4,208.4 187.2,208.5 183.2,173.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M112.8,154.4c-2.1,0-6.8,0.7-6.5,5.5c0.3,4.2,4.4,5,6.3,5.1c1.4,0,5.9-1,5.9-4.9 C118.5,155.4,114.7,154.5,112.8,154.4z M112.6,164.2c-1.6,0-5.1-0.7-5.3-4.3c-0.3-4,3.7-4.7,5.5-4.6c1.6,0,4.8,0.8,4.8,4.8 C117.6,163.3,113.8,164.2,112.6,164.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M112.8,155.3c-1.8,0-5.8,0.6-5.5,4.6c0.2,3.6,3.7,4.3,5.3,4.3c1.2,0,5-0.9,5-4.1 C117.5,156.1,114.4,155.3,112.8,155.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "110.5,156.6 109.3,162.4 110,162.6 111.4,156.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "113,155.9 111.4,163.7 112.2,163.7 113.6,155.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "114.7,157.1 113.5,163.1 114.3,163.1 115.3,157.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "115.8,158.8 115.1,162.1 115.6,162.1 116.3,159  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "109.5,157.5 108.7,161.3 108,161.1 108.8,157.5  "
  })))), /*#__PURE__*/React.createElement("polygon", {
    points: "115.6,164.8 115.5,164.4 108.9,164.2 109,164.8 108.5,164.8 108.5,166.5 116.3,166.8 116.3,164.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M184.9,154.9c-2.1,0-6.8,0.7-6.5,5.5c0.3,4.2,4.4,5,6.3,5.1c1.4,0,5.9-1,5.9-4.9 C190.5,155.8,186.8,154.9,184.9,154.9z M184.7,164.6c-1.6,0-5.1-0.7-5.3-4.3c-0.3-4,3.7-4.7,5.5-4.6c1.6,0,4.8,0.8,4.8,4.8 C189.6,163.7,185.9,164.6,184.7,164.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M184.8,155.7c-1.8,0-5.8,0.6-5.5,4.6c0.2,3.6,3.7,4.3,5.3,4.3c1.2,0,5-0.9,5-4.1 C189.6,156.5,186.4,155.7,184.8,155.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "182.6,157 181.4,162.8 182.1,163 183.4,157.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "185,156.3 183.4,164.1 184.2,164.1 185.7,156.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "186.8,157.5 185.6,163.5 186.4,163.5 187.3,157.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "187.8,159.2 187.2,162.5 187.7,162.5 188.3,159.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "181.5,157.9 180.8,161.7 180,161.5 180.9,157.9  "
  })))), /*#__PURE__*/React.createElement("polygon", {
    points: "187.6,165.2 187.5,164.8 181,164.6 181.1,165.2 180.5,165.2 180.5,166.9 188.4,167.2 188.4,165.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "125,166.2 118.7,174.2 129.3,174.2 135.5,166.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "135.5,166.3 129.3,174.2 140,174.2 146.1,166.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "114.4,166.1 108.1,174.2 118.7,174.2 125,166.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "146.1,166.4 140,174.2 150.6,174.2 156.7,166.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "107.3,166.1 106.5,168.6 104.9,168.7 104.9,174.2 108.1,174.2 114.4,166.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "177.8,166.7 171.8,174.3 182.5,174.3 188.4,166.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "191.7,166.8 188.4,166.7 182.5,174.3 192,174.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "156.7,166.5 150.6,174.2 161.2,174.3 167.2,166.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "167.2,166.6 161.2,174.3 171.8,174.3 177.8,166.7  "
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M100.7,100.3c0,9.2-7.8,9.7-14.9,9.7c-7.1,0-15.2-0.4-15.2-9.2c0-6.4,7.8-8.9,15-8.9 C92.7,91.9,100.7,94,100.7,100.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M75.7,142.2c0-0.3,0.4-0.3,0.6-0.3c0.6,0,1.2,0,1.8-0.3c0.3-0.1,0.6-0.2,0.8-0.5 c0.2-0.2,0.4-0.4,0.5-0.6c0.4-0.4,0.7-0.9,0.9-1.4c0.4-0.7,0.7-1.4,0.9-2.2c-0.6-0.6-1.5-1.4-2.6-2.2 c0.6,2.4,0.3,5.3-1.6,6.3c-3.1,1.6-5.7-2-6.4-1c-0.6,0.9,5.8,3.2,8.1,3.3c-0.8-0.1-1.7-0.5-2.5-0.8 C76.1,142.5,75.7,142.4,75.7,142.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M79.4,143.3c1-0.7,2.9-5.2,2.9-5.2s-0.3-0.5-1-1.2c-0.2,0.8-0.5,1.6-0.9,2.2 c-0.3,0.5-0.6,0.9-0.9,1.4c-0.2,0.2-0.3,0.5-0.5,0.6c-0.2,0.2-0.5,0.3-0.8,0.5c-0.5,0.3-1.2,0.3-1.8,0.3 c-0.2,0-0.6,0-0.6,0.3c0,0.2,0.3,0.4,0.5,0.4c0.8,0.3,1.6,0.7,2.5,0.8C79,143.4,79.3,143.4,79.4,143.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M95.5,130.5c-1.3-1.6-8.5-7-9.5-7.2c-0.4-0.1-0.7-0.1-0.9-0.1c-1,1.1-1.9,2.5-0.9,3.6 c1.8,2.1,4.5,7.3,7.2,5.2c0,0-1.4,2.3-2.9,3.1c-1.5,0.9-5.7,9-5.5,10.9c0.1,1.8-2.6,14.6,10.1,13.7c0.6-0.6,1-1.2,1.3-1.7 C94.8,156.7,96.8,132.1,95.5,130.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M72.4,140.5c-0.5-0.3-0.9-0.5-1.2-0.6C71.6,140.2,72,140.3,72.4,140.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M71.2,139.9c0.3,0.1,0.7,0.3,1.2,0.6c0,0,0,0,0,0c0,0,0,0,0,0c1.2,0.7,2.9,1.5,4.7,0.6 c1.9-1,2.2-4,1.6-6.3c-1.7-1.1-4-2.1-6.9-2c-2,0.1-3.1,1.6-3.7,3.7C68.8,137.8,69.8,139.1,71.2,139.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M82.9,146c-0.1-1.9,4-10,5.5-10.9c1.5-0.9,2.9-3.1,2.9-3.1c-2.7,2-5.4-3.1-7.2-5.2 c-0.9-1.1-0.1-2.5,0.9-3.6c-0.3,0-0.5,0.1-0.5,0.1s-3.1,0.8-2.8,2.4c0.3,1.6,3.2,5.5,3.2,5.5l-2.7,7c0,0-1.8,4.5-2.9,5.2 c-1,0.7-9.4-2.2-8.8-3.2c0.1-0.2,0.3-0.2,0.6-0.2c-1.4-0.8-2.4-2.1-3.2-3.4c-1.3,5.2,0.7,14.1,1.5,15.3 c0,0,17.8,10.2,20,9.8c1.3-0.2,2.6-1,3.4-1.8C80.4,160.6,83.1,147.8,82.9,146z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M95,124.4c0,0,2.4,0.4,2.5,1.4c0.2,1-0.6,5.8-2.5,6.1c-1.9,0.4-1.9-2.5-1.9-2.5L95,124.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M92.5,122.2c0,0,4.1,0.6,3.4,2c-0.7,1.4-1.4,6.1-2.8,5.9c-2.5-0.3-2.1-2.1-2.1-2.1L92.5,122.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M88.5,123.9c0,0,1.8-3.7,3.7-3.2c1.9,0.5,0.1,7.4-0.8,8.2c-1.6,1.3-3.6-0.8-3.5-1.3 c0.4-1.4,2.5-3.1,2.5-3.1L88.5,123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M86.6,123.1c0,0-2.1-10.1,0-10.7c2.1-0.6,3.9,5.1,3.5,10.5C89.8,128.3,86.6,123.1,86.6,123.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M83.9,123.5c0,0,4.8-2.9,6.3-0.8c1.5,2.1,2.4,2.3,1.3,3.4c-1.1,1.1-2.8,1.8-4.8-0.8 C84.8,122.6,85.4,123.5,83.9,123.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M79.4,132.1c0,0.2-0.2,0.4-0.4,0.5c-1.9,0.8-3.5,4.4-4,5.8c-0.1,0.3-0.5,0.5-0.8,0.4 c-0.3-0.1-0.5-0.5-0.4-0.8c0.1-0.2,1.9-5.4,4.7-6.5c0.3-0.1,0.7,0,0.8,0.4C79.4,131.9,79.4,132,79.4,132.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M82.4,132.5c0.2,0.1,0.3,0.3,0.3,0.6c0,2,2.7,5,3.8,5.9c0.3,0.2,0.3,0.6,0,0.9c-0.2,0.3-0.6,0.3-0.9,0 c-0.2-0.2-4.3-3.9-4.2-6.9c0-0.4,0.3-0.6,0.6-0.6C82.2,132.4,82.3,132.4,82.4,132.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M81.4,134.1c0,0.2,0,0.3-0.2,0.5c-1.2,1-1.5,4-1.5,5c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.5 c0-0.2,0-4.2,1.8-5.7c0.2-0.2,0.5-0.2,0.7,0C81.4,134,81.4,134.1,81.4,134.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M80.1,133.2c0,0.2,0,0.3-0.2,0.5c-1.5,1.1-2.1,4.1-2.1,5.2c0,0.3-0.3,0.5-0.7,0.5 c-0.3,0-0.6-0.2-0.6-0.4c0-0.2,0.3-4.3,2.6-5.9c0.3-0.2,0.7-0.2,0.9,0C80.1,133,80.1,133.1,80.1,133.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M82.9,130.8c0.2,0,0.3,0.1,0.4,0.3c0.5,1.5,3.1,2.9,4.1,3.3c0.2,0.1,0.4,0.4,0.3,0.7 c-0.1,0.3-0.4,0.4-0.6,0.3c-0.2-0.1-3.9-1.7-4.7-3.9c-0.1-0.3,0-0.6,0.3-0.7C82.7,130.8,82.8,130.8,82.9,130.8z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "31.5,131.9 34.4,148.9 65.7,155.8 71.6,142.8 71.6,132.1 64.3,131.9  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M15.5,167.3c-0.1-3.4,3-12.6,5.4-18.4c1.6-3.7,0.8-10.2,0.1-14.3c-4.8,2.7-9.8,7.3-11.9,14.9 c-4.9,17.7-3.3,22.3-3.3,22.3c0.1,0.6,1,0.5,1.1,1.1c0.2,0.8,0.3,1.5,0.8,1.9c0.5,0.4,1.1,0.8,1.6,1 C13.5,176.4,15.6,169.7,15.5,167.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M31.8,130.8c0,0-5.2,0.6-10.8,3.8c0.8,4.1,1.5,10.5-0.1,14.3c-2.4,5.8-5.5,15-5.4,18.4 c0.1,2.4-2,9.1-6.2,8.6c0.3,0.1,0.5,0.2,0.7,0.2c0.1,0,0.3,1.3,1.3,1.5c1.5,0.3,2.6,0.3,3.5,0.2c0.6,0,0.2-1.2,1.7-1.4 c1.1-0.1,1.4-1.4,1.8-2.4c0,0,1.5,0,2.3-0.5c1.3-0.8,2.8-6,1.1-7c-1.7-0.9-1-2.2-0.9-3.2c0.1-1,1.1-7.9,5.2-9.9 c4.2-2,10.5-2.4,10.5-2.4S34.7,132.9,31.8,130.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M28.4,116c0,0,14.8,3.8,23.1,3.3c8.3-0.4,21.7-3.3,21.7-3.3l-2.8-2l-6-1.9l-17.2-1.5l-12.9,2.9 L28.4,116z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M32,119.8c0,0.1-1,2.7,1.1,2.4c2.1-0.2,2.8-1.6,2.8-1.6l-0.3-3.5c-2.1,0.4-3.5,0.8-4.1,1 C31.8,119,32,119.8,32,119.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M30.8,114.7c0.1,1,0.4,2.3,0.7,3.4c0.6-0.2,2-0.6,4.1-1l-0.4-4.1C35.2,113,30.6,112.8,30.8,114.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M70.7,114.7c0.2-1.9-4.4-1.8-4.4-1.8l-0.4,4.1c1.3,0.3,2.7,0.6,4.1,1.1 C70.3,117.1,70.6,115.7,70.7,114.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M70,118.1c-1.4-0.4-2.7-0.8-4.1-1.1l-0.3,3.6c0,0,0.7,1.4,2.8,1.6c2.1,0.2,1.1-2.3,1.1-2.4 C69.6,119.8,69.8,119.1,70,118.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M65.1,116.9l-0.8-6.4l-22-0.9l-6.4,1.7c0,0-0.2,2.7-0.3,5.8C41.6,115.9,52.9,114.3,65.1,116.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M40.4,116.3c-1.9,0.3-3.5,0.6-4.8,0.8c-0.1,3.4-0.3,7.1-0.1,7.8c0.4,1.4,8.3,6.8,8.3,6.8l1-0.1 C40.1,126,40.1,119.1,40.4,116.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M65.9,122.5l-0.7-5.6c-9.5-2-18.4-1.5-24.7-0.6c-0.3,2.9-0.4,9.7,4.4,15.4l18.7-1L65.9,122.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M43.7,126.2c0.1,0,0.3-0.1,0.4-0.1c0.2-0.7,0.3-1.2,0.3-1.2s-0.1,0.4-0.3,1.2c1.7-0.6,2.6-2.4,2.8-4.1 c-2.6,0.7-4.4,1.9-5.7,2.8C41.4,125.5,42,126.6,43.7,126.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M45.5,140.7c-3.4-1.5-2.7-8.2-1.9-12.4l0.7-0.2L46,129l2.8-0.7l1.4-1.5c0,0,1.3-2.3,1.3-4.6 c0-0.3,0-0.7-0.1-1c-1.7,0.1-3.2,0.4-4.5,0.7c-0.1,1.7-1,3.5-2.8,4.1c-0.1,0-0.2,0.1-0.4,0.1c-1.7,0.4-2.4-0.7-2.6-1.4 c-1.5,1.1-2.3,2.1-2.9,2c-1.4-0.2-2.3-12.7-1.9-14c0.4-1.3-1.4,0.5-1.4,0.5S32.1,137,36,140c3.9,3,11.7,3.5,15.6,3.5 c3.2,0,11.5-0.2,14.8-4.6C60.4,142.7,49.7,142.6,45.5,140.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M64.3,116.7c-0.2,3.5-0.6,7.7-1.7,8.6c0,0-4.7-4.1-9.7-4.2c-0.5,0-1,0-1.5,0c0,0.3,0,0.6,0.1,1 c0.1,2.2-1.3,4.6-1.3,4.6l-1.4,1.5L46,129l-1.7-0.9l-0.7,0.2c-0.8,4.2-1.5,10.9,1.9,12.4c4.2,1.9,14.9,2,20.8-1.8 c0.7-0.9,1.1-1.9,1.3-3.1c0.7-4.8-0.1-13.1-0.8-18.5L64.3,116.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M66.8,117.3c-0.4-3-0.8-5.1-0.8-5.1h-1.6c0,0,0,2.1-0.1,4.6c0,0,0,0,0,0L66.8,117.3 C66.8,117.3,66.8,117.3,66.8,117.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M55.4,108.4c-7.3-0.3-4.4-3.3-4.4-3.3L50.6,93c-1.3,0.1-2.6,0.2-3.7,0.4c0,2.5-0.2,12.5-3.9,13.5 c-2.1,0.5-6,1.2-9.6,3.1c0.2,1.2,0.4,2,0.4,2h4.9l7-1.4l6.2-0.3C52.6,108.9,55.4,108.4,55.4,108.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64.3,97.5c-0.1,0.3-1.7,6.3-5,5c-3.2-1.3-1.4-8.5-1.2-9.1c0,0,0,0,0,0c-1-0.7-4.3-0.7-7.6-0.4 l0.5,12.1c0,0-2.9,3,4.4,3.3c0,0-2.8,0.5-3.5,1.9l3.1-0.1l8.9,1.9h4C70.6,100.8,65.2,97.8,64.3,97.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M46.9,93.4c-1.5,0.2-2.8,0.4-3.4,0.6c0,0,0,0,0,0c0.1,0.5,2.1,7.8-1.2,9.1c-3.3,1.3-4.9-4.6-5-5 c-4.8,2.4-4.5,8.6-4,11.8c3.7-1.9,7.6-2.6,9.6-3.1C46.7,105.9,46.9,95.9,46.9,93.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M59.3,102.5c3.3,1.3,4.9-4.6,5-5c0,0,0,0,0,0c-0.7,0.4-1.9,1-4.2,0.2c-2.4-0.8-1.6-4-2-4.3 C58,94,56.1,101.2,59.3,102.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M42.3,103.1c3.3-1.3,1.3-8.6,1.2-9.1c-0.6,0.3,0.3,2.4-2.7,4.1c-2.2,1.2-3.4,0-3.4,0c0,0,0,0,0,0 C37.4,98.6,39,104.4,42.3,103.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M50.4,90.4c-1.2,0.2-2.3,1.8-2,5.9c0.3,4.3,0.4,9.5,2.8,9.5c0.4,0,0.8-0.3,1-0.7 C48.5,99.6,49.7,93.2,50.4,90.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M53.3,95.6c0-1.4,0-5.4-2.7-5.3c-0.1,0-0.1,0-0.2,0c-0.8,2.8-1.9,9.3,1.8,14.7 C53.5,103.2,53.3,97.7,53.3,95.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M55.4,108.4c-0.9,0-1.7-0.1-2.3-0.2c-1.4-0.1-2.3-0.2-2.3-0.2s-20.4,0.8-22.4,8c0,0,12.6-4,22.4-4.3 c0.4,0,0.7,0,1.1,0.1C50.7,109.3,55.4,108.4,55.4,108.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M53.1,108.2c0.6,0.1,1.4,0.2,2.3,0.2c0,0-4.7,0.9-3.5,3.4c9.6,0.6,21.3,4.3,21.3,4.3 C71.6,110.3,58.5,108.6,53.1,108.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M43.7,117c0-0.7-0.5-1.2-1.2-1.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2C43.2,118.2,43.7,117.6,43.7,117z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M38.6,116.9c0,0,6.8-0.3,7.7-0.9c0.9-0.6,0.4-2.1-0.8-2c-1.2,0.1-1.3,0.1-2.8,0 c-1.5-0.1-1.9,0.4-3.1,0.5C38.9,114.6,37.6,115.6,38.6,116.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58,117c0-0.7,0.5-1.2,1.2-1.2s1.2,0.5,1.2,1.2c0,0.7-0.5,1.2-1.2,1.2S58,117.6,58,117z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M63.1,116.9c0,0-6.8-0.3-7.7-0.9c-0.9-0.6-0.4-2.1,0.8-2c1.2,0.1,1.3,0.1,2.8,0 c1.5-0.1,1.9,0.4,3.1,0.5C62.8,114.6,64.1,115.6,63.1,116.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M48.6,129.8c0,0.2,0.1,0.4,0.2,0.6c0.3,0.8,1.1,1.6,2.9,1.6c0.7,0,1.3-0.2,1.7-0.5 C51.4,128,49.5,129,48.6,129.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M54.6,128.3l-1.5-0.9l-1.6-1.9l-0.8,0.3l-0.7,1.6l-1.4,1.2c0,0-0.1,0.6,0,1.2c0.9-0.7,2.8-1.7,4.8,1.7 c0.5-0.3,0.8-0.7,1-1.1C54.8,129.4,54.6,128.3,54.6,128.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M38.4,126.8L38.4,126.8C38.4,126.8,38.4,126.8,38.4,126.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M61.8,124.7c-0.1-0.1-0.7,2.7-3.9,1.4c-0.2-0.1-0.4-0.1-0.5,0.1c-0.1,0.1-0.2,0.3-0.1,0.5 c0,0.2-0.3,0.8-1.8,0.9c-1.1,0.1-2.1-0.3-2.8-1c-0.6-0.6-1-1.4-1.2-2.4c0-0.6,0-1.2,0-1.9c0-0.3-0.3-0.5-0.5-0.5 c-0.1-0.1-0.2-0.1-0.3-0.1c-0.3,0-0.5,0.3-0.4,0.6c0,0.6,0.1,1.2,0.2,1.8c-0.1,1.2-0.4,2.2-0.9,3c-0.6,0.9-1.6,1.4-2.8,1.5 c-1.6,0.1-2-0.4-2-0.6c0-0.2-0.1-0.4-0.2-0.5c-0.2-0.1-0.4-0.1-0.5,0c-3.2,1.8-4.6-1.1-4.7-1c-0.8,0.6-0.8,0.5-0.9,0.5 c0,0.1,1.8,3.5,5.5,1.8c0.1,0.1,0.1,0.2,0.2,0.3c0.5,0.5,1.2,0.7,2.2,0.7c0.2,0,0.4,0,0.5,0c1.5-0.1,2.7-0.8,3.5-1.9 c0.4-0.5,0.6-1,0.8-1.7c0.3,0.5,0.6,1,1,1.4c0.9,1,2.1,1.5,3.5,1.4c0.2,0,0.3,0,0.5-0.1c0.9-0.1,1.5-0.5,1.9-1 c0.1-0.1,0.1-0.2,0.2-0.3c3.7,1.2,4.5-2,4.5-2C62.6,125.4,62.2,125.1,61.8,124.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M30.2,118.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M31.2,118.2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M49.9,114.8c-1.1,0.2-1.6,7.5-0.3,7.3c1.2-0.2,4.3,2.7,5.4,1.1c0.1-2.1-1.2-5.4-2.9-7.7l0,0 C52,115.5,51,114.6,49.9,114.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M49.6,122.2c-1.2,0.2-0.8-7.1,0.3-7.3c1.1-0.2,2.1,0.7,2.1,0.7l0,0c-1-1.3-2.1-2.2-3.2-2.3 c-1.4-0.1-0.9,12,0.5,12.2c1.4,0.2,1.5-0.2,1.7-0.2c0.2,0,1.5,0.7,3.2-0.1c0.5-0.3,0.8-1,0.8-1.8 C53.9,124.8,50.7,122,49.6,122.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M34.1,195.5c-0.4,1.3-0.5,4-0.7,6.2l2.9-0.1l1.1-5.7C36.7,195.1,34.6,193.7,34.1,195.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M66.1,195.2c-0.4,1.6-0.4,4.1-0.4,6.3l4.8,0.2l2.4-9.9C70.9,192,66.7,192.7,66.1,195.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M75.6,190.3l0.7-7l-25.2-1.7L27,180.1l-1,2.7l1.3,6.1l1.6,1.2l0.5,11.8l3.9-0.2 c0.1-2.2,0.3-4.8,0.7-6.2c0.5-1.8,2.6-0.4,3.4,0.3l0.4-2.1c0,0,4.4,2.8,14.8,2.4c10.3-0.4,10.9-2.2,10.9-2.2v7.5l2.1,0.1 c-0.1-2.2,0-4.7,0.4-6.3c0.6-2.5,4.8-3.2,6.9-3.4l0.2-0.8L75.6,190.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M51.9,195.5c-1,0-1.8-0.3-2.2-1c-1.2-1.6-0.3-4.4-0.3-4.5l0.6,0.2c0,0-0.8,2.7,0.2,4 c0.4,0.5,1,0.8,1.8,0.8V195.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "52.2,196.2 51.6,196.1 51.8,190.1 52.4,190.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M25,179.4l0.7,3.2c0,0,13.4,7.2,23.9,7.1v-2.1C49.7,187.5,33.8,184.5,25,179.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M78.4,183l-0.9,3.1c0,0-12,5-22.6,4.1l0.1-2.1C55,188.1,69.3,187.5,78.4,183z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M47.4,187.1c0,0-0.3,3,0.8,3.2c1.2,0.3,6.8,0.4,6.8,0.4s2.6,0.1,2.1-3.2 C56.6,184.1,47.4,187.1,47.4,187.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "40.8,185.9 40.8,189.4 42.4,189.6 42.7,186.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "61.6,187 61.6,190.5 60,190.7 59.6,187.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "67.1,186.3 67.1,189.8 65.5,190.1 65.1,187.1  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "75.6,184 75.6,187.3 74,187.7 73.7,184.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "34.4,184 34.4,187.1 36,187.8 36.4,184.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "28,181.1 28,184 29.6,184.8 29.9,181.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M71.8,169c-1.6,0.2-3.3,0.3-4.9,0.5c-1.6,0.2-3.8,0-5.1,1.1c1.2,0.7,3.2,0.2,4.6,0.3 c1.9,0.1,3.7,0.1,5.6,0.1c1.6,0,3.3,0.2,4.8-0.3c0.4-0.1,0.8-0.3,1.1-0.6c-0.5-1.1-1.1-2.2-1.3-2.8 c-0.1,0.1-0.1,0.2-0.2,0.3C75.2,168.8,73.5,168.7,71.8,169z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M27.9,172.1c1.8-0.4,5.5-0.8,5-3.5c-2-0.8-4.2-0.9-6.2-1.8c-0.8-0.3-1.8-0.9-2.5-1.7 c0.1,0.8,0.2,1.3,0.2,1.3s-0.6,3-1.2,4.3c-0.2,0.5-0.6,1.2-0.9,1.8c0.1,0,0.1,0,0.2,0C24.4,172.6,26.2,172.5,27.9,172.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M78.6,177.9c-1.1,1.2-2.8,1.9-4.3,2.6c-1.4,0.7-2.9,1-4.3,1.6c-1.5,0.6-3,1.3-4.6,1.7 c-5.1,1.1-10.5,0.6-15.6,1.6c0.3,0.6,1.6,0.4,2.3,0.4c1.5,0,3.1,0.1,4.6,0.1c2.4,0,4.6-0.2,6.9-0.5 c1.2-0.2,2.4-0.6,3.6-0.7c1.1-0.1,2.2-0.2,3.3-0.5c2.2-0.5,4.5-0.8,6.7-1.6c0.7-0.2,1.3-0.6,2-1c-0.1-1-0.4-1.9-0.5-2.4 C78.6,179,78.6,178.5,78.6,177.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M25.3,178.7c0.9,0.3,2,0.5,2.8,1c0.5,0.3,0.8,0.5,1.3,0.7c0.5,0.2,0.9,0.3,1.4,0.4 c2.2,0.5,4.3,1.6,6.6,1.5c0.3,0,0.8,0,0.7-0.5c-0.1-0.4-0.4-0.4-0.7-0.4c-1.8-0.2-3.5-1.1-5.3-1.6c-1.9-0.6-3.8-1.2-5.6-2 c-0.6-0.3-1.1-0.5-1.7-0.8c-0.2-0.1-0.5-0.3-0.7-0.4c0.5,0.7-0.5,0.7-0.9,1.6c-0.1,0.3-0.2,0.5-0.3,0.8 c0.1-0.1,0.3-0.2,0.4-0.3C23.9,178.4,24.8,178.6,25.3,178.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M70.4,184.1c-1.1,0.3-2.1,0.4-3.3,0.5c-1.2,0.1-2.4,0.5-3.6,0.7c-2.3,0.3-4.5,0.5-6.9,0.5 c-1.5,0-3-0.1-4.6-0.1c-0.7,0-2,0.2-2.3-0.4c5.1-1,10.5-0.5,15.6-1.6c1.6-0.4,3.1-1,4.6-1.7c1.4-0.6,2.9-0.9,4.3-1.6 c1.4-0.7,3.1-1.4,4.3-2.6c0-1.5,0.1-3.7,0-5.3c0-0.8-0.4-1.7-0.8-2.5c-0.3,0.2-0.6,0.4-1.1,0.6c-1.5,0.5-3.2,0.3-4.8,0.3 c-1.9,0-3.8,0-5.6-0.1c-1.4-0.1-3.4,0.4-4.6-0.3c1.3-1.1,3.5-0.9,5.1-1.1c1.6-0.2,3.3-0.3,4.9-0.5c1.7-0.3,3.3-0.2,4.5-1.4 c0.1-0.1,0.2-0.2,0.2-0.3c0-0.2,0-0.4,0-0.5c0.4-0.7-0.1-11.2-0.1-11.2c-4.3-3-2.6-22.9-2.6-22.9l-4.8-1.4 c0,0-0.5,13.9-1.5,15.8c-1,1.9-24.6,2.9-29.4,2C33.3,148.3,34,130,34,130l-4.8,1.3c0,7.1,1.2,14,0,17.3 c-0.9,2.6-5,5.9-5,5.9c-1,3.8-0.4,8.4,0,10.7c0.8,0.8,1.8,1.4,2.5,1.7c2,0.8,4.3,1,6.2,1.8c0.5,2.6-3.3,3.1-5,3.5 c-1.8,0.3-3.5,0.5-5.3,0.5c-0.1,0-0.1,0-0.2,0c-0.3,0.9-0.4,2,0.9,3c0.5,0.4,0.8,0.7,0.9,0.9c0.2,0.1,0.5,0.3,0.7,0.4 c0.5,0.3,1.1,0.6,1.7,0.8c1.8,0.8,3.7,1.5,5.6,2c1.7,0.5,3.5,1.4,5.3,1.6c0.3,0,0.7,0,0.7,0.4c0.1,0.5-0.4,0.5-0.7,0.5 c-2.3,0.1-4.4-1-6.6-1.5c-0.5-0.1-0.9-0.2-1.4-0.4c-0.5-0.2-0.9-0.4-1.3-0.7c-0.8-0.5-1.8-0.7-2.8-1 c-0.5-0.2-1.4-0.3-2-0.1c-0.1,0.1-0.2,0.1-0.4,0.3c-0.6,2.3,2.7,1.9,2.7,1.9s12.9,7.6,26.4,7.8c13.6,0.2,25.4-4,26.5-5 c0.5-0.4,0.5-1.2,0.4-2c-0.7,0.4-1.3,0.7-2,1C74.9,183.3,72.6,183.6,70.4,184.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M30,190.7l-0.1-0.6c0.1,0,2.6-0.6,2.6-2.6l0.6,0C33,190.1,30,190.7,30,190.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M70.6,194.2c-3.3-0.5-3.1-3.7-3.1-3.7l0.6,0.1l-0.3,0l0.3,0c0,0.1-0.2,2.6,2.6,3L70.6,194.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 36.1,
    y: 193.2,
    transform: "matrix(0.1026 -0.9947 0.9947 0.1026 -159.6944 209.6717)",
    className: "st34",
    width: 0.4,
    height: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M35.7,200.7l-0.3,0l0.1-0.9l0.3,0L35.7,200.7z M35.9,198.9l-0.3,0l0.1-0.9l0.3,0L35.9,198.9z  M36.1,197.1l-0.3,0l0.1-0.9l0.3,0L36.1,197.1z M36.3,195.4l-0.3,0l0.1-0.9l0.3,0L36.3,195.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 35.2,
    y: 201.7,
    transform: "matrix(0.1063 -0.9943 0.9943 0.1063 -168.9885 215.585)",
    className: "st34",
    width: 0.4,
    height: 0.3
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M64.6,202.2h-0.3v-0.9h0.3V202.2z M64.6,200.4h-0.3v-0.9h0.3V200.4z M64.6,198.6h-0.3v-0.9h0.3V198.6 z M64.6,196.9h-0.3V196h0.3V196.9z M64.6,195.1h-0.3v-0.9h0.3V195.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M72.3,207.5c-1.7,0.1-4.2-0.2-5.5-0.7h-3.1l-1,0.1v1.9l1.7,0.4l0.2-0.6l1.3,0v0.8h1.9v-0.5l1.9,0v0.8 h1.8v-0.8l0.7-0.1C72.1,208.1,72.3,207.5,72.3,207.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M72.8,209.2l2-0.7v-1.7h-1.7h-6.3c1.2,0.5,3.8,0.8,5.5,0.7c0,0-0.2,0.6-0.2,1.1l0.6-0.1L72.8,209.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M66.1,206.2c-0.2-0.5-0.4-2.8-0.4-5.2l-2.3-0.1l0.3,6.1c3.7,1.4,6.9,1,8.6,0.5l0,0 C70.1,207.6,66.4,207.1,66.1,206.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M70.5,203.9l0.4-2.7l-5.3-0.2c0,2.5,0.2,4.7,0.4,5.2c0.3,0.9,4,1.4,6.2,1.3l0,0 c0.9-0.2,1.4-0.5,1.4-0.5C73.9,204.6,70.5,203.9,70.5,203.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "36.3,206.8 37.3,206.9 37.3,208.8 35.7,209.2 35.5,208.6 34.2,208.6 34.2,209.3 32.3,209.3  32.3,208.8 30.4,208.7 30.4,209.5 28.6,209.5 28.6,208.7 27.3,208.5 27.2,209.2 25.1,208.5 25.1,206.8 26.8,206.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M33.1,204.9c-0.4,0.6,1,3-6.8,1.7c0,0.1,0,0.3,0,0.4c0,0,4.5,2.2,10,0l0.3-6.1l-3.1,0.1 C33.4,202.9,33.3,204.6,33.1,204.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M33.1,204.9c0.2-0.3,0.3-2,0.4-3.9l-4.5,0.2l0.4,2.7c0,0-3,0.6-3.1,2.7 C34.1,207.9,32.7,205.5,33.1,204.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M3.9,165.8c-0.3,0-0.5-0.2-0.6-0.5c0-0.3,0.2-0.6,0.5-0.7c2.9-0.4,7.5,0,7.7,0c0.3,0,0.6,0.3,0.5,0.6 c0,0.3-0.3,0.6-0.6,0.5C11.4,165.8,6.7,165.4,3.9,165.8C4,165.8,3.9,165.8,3.9,165.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M10.6,160.7c-0.3,0-5.7-0.3-6.8-0.4c-0.3,0-0.6-0.3-0.6-0.6c0-0.3,0.3-0.6,0.6-0.6 c2.5,0.2,6.4,0.4,6.7,0.4c0.3,0,0.6,0.3,0.6,0.6C11.2,160.4,11,160.7,10.6,160.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M11.4,156.8c0,0-0.1,0-0.1,0c-1.3-0.3-5-1.1-6.3-0.8c-0.3,0.1-0.6-0.1-0.7-0.4 c-0.1-0.3,0.1-0.6,0.4-0.7c1.8-0.4,6.4,0.7,6.9,0.8c0.3,0.1,0.5,0.4,0.4,0.7C12,156.7,11.7,156.8,11.4,156.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M12,153.8c0,0-0.1,0-0.1,0c-1-0.2-3.7-0.8-5-0.5c-0.3,0.1-0.6-0.1-0.7-0.4c-0.1-0.3,0.1-0.6,0.4-0.7 c1.9-0.4,5.4,0.5,5.6,0.5c0.3,0.1,0.5,0.4,0.4,0.7C12.5,153.6,12.2,153.8,12,153.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M14.9,148.9c0,0-0.1,0-0.1,0c-3.6-0.7-8,0-8,0c-0.3,0.1-0.6-0.2-0.7-0.5c-0.1-0.3,0.2-0.6,0.5-0.7 c0.2,0,4.6-0.7,8.4,0c0.3,0.1,0.5,0.4,0.5,0.7C15.4,148.7,15.2,148.9,14.9,148.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M14.5,144.6c-0.1,0-0.2,0-0.2-0.1c-1.6-0.7-4.9-0.6-6.1-0.5c-0.3,0-0.6-0.2-0.6-0.5 c0-0.3,0.2-0.6,0.5-0.6c0.2,0,4.5-0.4,6.7,0.6c0.3,0.1,0.4,0.5,0.3,0.8C14.9,144.5,14.7,144.6,14.5,144.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M10.6,162.9C10.6,162.9,10.6,162.9,10.6,162.9c-2.1-0.3-5.7,0-5.8,0c-0.3,0-0.6-0.2-0.6-0.5 c0-0.3,0.2-0.6,0.5-0.6c0.2,0,3.8-0.3,5.9,0c0.3,0,0.6,0.3,0.5,0.7C11.2,162.7,10.9,162.9,10.6,162.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M17.5,143.4c-0.2,0-0.4-0.1-0.5-0.3c-0.9-1.6-4.5-2.8-5.7-3.1c-0.3-0.1-0.5-0.4-0.4-0.7 c0.1-0.3,0.4-0.5,0.7-0.4c0.2,0,5.2,1.2,6.5,3.7c0.2,0.3,0,0.6-0.2,0.8C17.6,143.4,17.5,143.4,17.5,143.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M100,100.7c0,9.2-7.8,9.7-14.9,9.7c-7.1,0-15.2-0.4-15.2-9.2c0-6.4,7.8-8.9,15-8.9 C92,92.3,100,94.3,100,100.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "78,108.8 74.7,117.9 85.1,109.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.3,103.5v1.9h-3.8l-0.1-0.1v-0.1l0-0.2v-2.7l0,0l0.3,0h0.6v2l0.1,0.1h0.6l0.1-0.1l0,0h1l-0.1-0.3 v-1.3l-1.7-1.1l-0.9-0.7h-0.1l-0.1-0.2v-0.4l-0.1-0.8v-1.4H77l1.1,0v2.5l-0.1,0l-0.6,0l-0.3,0l-0.1-0.1v-1.4L77,99.2 l-0.3-0.1h-0.2l-0.1,0.1h-1.1v0.5l0.1,0.7l2,1.3l0.7,0.4L78.3,103.5L78.3,103.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82.5,103.6l0,0.2l0,0.4l0,0.1l0,0l-0.1,0l0,0.1l0.1,0.2l-0.1,0.1l0.1,0l0,0.3l0,0.6l-0.1,0l-0.1-0.1 l0,0.1h-0.1l0-0.1l0,0l-0.1,0h-0.4l-0.1,0v0h-0.5l-0.5,0l0,0.1h-0.8l-0.6-0.1l0,0l0,0H79l-0.1-1.9v-3l0.1-0.3V100l-0.1-0.1 l0.1-0.2v-0.1l-0.1,0l0.1-0.1l-0.1-1.4h3.4l0.2,0.1v1.4l0.1,0.1l0,0.1l-0.1,0.2l0.1,0l0,0.5l0.1,0l0,0.5l0.1,0.1v0.1 l-0.1,0.1l0.1,0.2l-0.1,0l0,0.1l0,0.1v0.2l0,0.1l0,0.1l0,0.1l0,0.1l0.1,0l0,0.1L82.5,103.6L82.5,103.6L82.5,103.6z  M81.5,103.5l0-0.6l-0.1-0.1v-2.1l-0.1,0l0.1-0.1v-1l0-0.3h-1.6l0,0.6l0,0.1l0,0v0l-0.1,0.1l0.1,0.2v1.3l0.1,0.1l0,0l-0.1,0 l0.1,0.1l-0.2,0.1l0.1,0.6l0,0.9l-0.1,0l0.1,0.1v0.2l0,0.4l0,0.1l0.9-0.1h0.6v-0.5l0-0.1l0.1,0V103.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M87,99.8l0,0.2v1l-0.9,0.1l0.1,0.8l0,0l0.4,1.8l0,0.1l0.3,1.6h-0.9l-1-4.4l-0.1,0h-0.3l-0.2,0l-0.1,0 l0.1,2l-0.1,0.1l0.1,0.2v0.1l0,0.1l0.1,0.3l-0.1,0.1l0.1,0.1l-0.1,0.4v0.6l0,0.3h-1l0-0.3v-3.2l-0.1-1.5l0-0.9v-1l0-0.1h3.6 l0.1,0.1l0,0.1L87,99.8L87,99.8z M85.9,99.5l0-0.2h-1.6v0.5l1.6,0L85.9,99.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M87.8,104.3l-0.1-0.1l0.1-0.1v-1.3l-0.1-0.1l0,0v-0.5l-0.1-0.1l0-0.3v-3.6h3.7v0.2l0.1,0.5v0.3l0,0.1 l0.2,1.5l0,0l-0.1,0l-0.6,0h-0.3l-0.1,0.1l0.2,1.1l0.4,1.6l0.1,0.5l0,0l0.1,0.1l0.1,0.4l0,0.1l0.1,0.1l0.1,0.5h-1l-0.4-1.3 l-0.1-0.5l-0.4-1.9l-0.1-0.8h-0.7l0.2,2.1v0.8l0,0.7l-0.1,0.9l-1,0l-0.1-0.1l0-0.2V104.3z M87.8,105.2L87.8,105.2L87.8,105.2 L87.8,105.2z M90.6,100l0-0.3l0-0.4h-1.8l0.1,0.3v0.2l-0.1,0.1H90.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M95.7,98.2l-0.5,1.1l-0.5,1.5l-0.2,1.1v3.4h-1.1v-1.6l0.1-0.1l-0.1-0.1l0-0.2v-1.9l-0.8-2.3l-0.4-1h1.1 l0.6,2.3l0.2-0.9l0.5-1.4H95.7z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderConstructionSection);
export default __webpack_public_path__ + "static/media/under-construction-section.b45bae43fc08ad5028d370c36d5e1808.svg";
export { ForwardRef as ReactComponent };